 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->
<!--
testDriver
containerComponent
iteratorComponent

testDriver : false,
containerComponent : false,
iteratorComponent : false
-->
<script>
import ClassView from "../components/IteratorDiagramComponent.vue";
import ClerkView from "../components/ClerkComponent.vue";
import ContainerView from "../components/ContainerComponent.vue";
import CustomerView from "../components/CustomerComponent.vue";
import InstructionsView from "../components/IteratorInstructionsComponent.vue";
import IteratorView from "../components/IteratorComponent.vue";
import PersonView from "../components/PersonComponent.vue";
import ReservationSystemView from "../components/ReservationSystemEditableComponent.vue";
import ReservationView from "../components/ReservationComponent.vue";
import TestDriverComponent from "@/components/TestDriverIteratorComponent.vue";
import VehicleView from "../components/VehicleComponent.vue";


export default {
  components: {
    ClassView,
    ClerkView,
    ContainerView,
    CustomerView,
    InstructionsView,
    IteratorView,
    PersonView,
    ReservationSystemView,
    ReservationView,
    TestDriverComponent,
    VehicleView,

  },
  data() {
    return {
      componentSelect: "InstructionsView",
      testDriver: false,
      containerComponent: false,
      iteratorComponent: false,
      reservationComponent: false,
    };
  },
  methods: {

    testDriverCallback(value) {
      console.log("testDriverCallback");
      this.testDriver = value;
    },
    containerComponentCallback(value) {
      console.log("containerComponentCallback");
      this.containerComponent = value;
    },
    iteratorComponentCallback(value) {
      console.log("iteratorComponentCallback");
      this.iteratorComponent = value;
    },
    reservationComponentCallback(value) {
      console.log("reservationComponentCallback");
      this.reservationComponent = value;
    },
    instructionsReadCallback() {
      this.componentSelect = 'ContainerView'
    }

  },
};
</script>

<template>
  <main class="app">
    <div class="buttons">
      <button @click="componentSelect = 'InstructionsView'"
              :style="componentSelect === 'InstructionsView' ? 'background-color: #55acee' : ''">1. Instructions
      </button>
      <button @click="componentSelect = 'CustomerView'"
              :style="componentSelect === 'CustomerView' ? 'background-color: #55acee' : ''">2. Customer
      </button>
      <button @click="componentSelect = 'ClerkView'"
              :style="componentSelect === 'ClerkView' ? 'background-color: #55acee' : ''">3. Exec
      </button>
      <button @click="componentSelect = 'PersonView'"
              :style="componentSelect === 'PersonView' ? 'background-color: #55acee' : ''">4. Person
      </button>
      <button @click="componentSelect = 'ContainerView'"
              :style="componentSelect === 'ContainerView' ? 'background-color: #55acee' : ''">5. Container
      </button>
      <button @click="componentSelect = 'IteratorView'"
              :disabled="!containerComponent"
              :style="componentSelect === 'IteratorView' ? 'background-color: #55acee' : ''">6. Iterator
      </button>
      <button @click="componentSelect = 'ReservationSystemView'"
              :disabled="!iteratorComponent"
              :style="componentSelect === 'ReservationSystemView' ? 'background-color: #55acee' : ''">7. Reservation System
      </button>
      <button @click="componentSelect = 'ReservationView'"
              :style="componentSelect === 'ReservationView' ? 'background-color: #55acee' : ''">8. Reservation
      </button>
      <button @click="componentSelect = 'VehicleView'"
              :style="componentSelect === 'VehicleView' ? 'background-color: #55acee' : ''">9. Vehicle
      </button>
      <button @click="componentSelect = 'TestDriverComponent'"
              :disabled="!reservationComponent"
              :style="componentSelect === 'TestDriverComponent' ? 'background-color: #55acee' : ''">10. Test Driver
      </button>
      <button @click="componentSelect = 'ClassView'"
              :style="componentSelect === 'ClassView' ? 'background-color: #55acee' : ''">11. Class Diagram
      </button>
    </div>

    <KeepAlive>
      <component
          v-bind:is="componentSelect"
          @test-driver="testDriverCallback"
          @container-component="containerComponentCallback"
          @iterator-component="iteratorComponentCallback"
          @reservation-component="reservationComponentCallback"
          @instructions-read="instructionsReadCallback"
      />
    </KeepAlive>
  </main>
  <!--eslint-disable-next-line vue/no-multiple-template-root-->
  <footer v-show="(testDriver && containerComponent && iteratorComponent && reservationComponent)">
    <div id="buttons" class="relative">
      <button class="navitem" @click="$router.push('/screen-four')">Next</button>
    </div>
  </footer>
</template>

<style>
.app {
  background-color: #f9fafe;
  min-height: 1024px;
}

button {
  margin-top: 30px;
  border: none;
  padding: 20px;
  margin-left: 5px;
  background-color: #2c3e50;
  color: white;
  width: 500px;
}

button:first-of-type {
  margin-left: 30px;
}

.buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 0;
}
</style>
 